import { Route, Switch } from "react-router-dom";

//Main Website imports
import About from "./pages/About";
import Contact from "./pages/Contact";
import Home from "./pages/Home";
import Clients from "./pages/Clients";
import Thanks from "./pages/Thanks";
import Services from "./pages/Services";

import Layout from "./components/layout/Layout";

function App() {
  return (
    <Layout>
      <Switch>
        <Route path="/" exact={true}>
          <Home />
        </Route>
        <Route path="/about">
          <About />
        </Route>
        <Route path="/clients">
          <Clients />
        </Route>
        <Route path="/contact">
          <Contact />
        </Route>
        <Route path="/services">
          <Services />
        </Route>
        <Route path="/thanks">
          <Thanks />
        </Route>
      </Switch>
    </Layout>
  );
}

export default App;
